export default "__VITE_ASSET__t2c$DPMQ__"